import { DEFAULT_LANG } from './i18n.js';
/**
 * Fuqarolikni ko'rsatish uchun mamlakatlar.
 *
 * MyID fuqarolikni MATN bilan bermaydi — faqat kod: `citizenship_id`
 * (o'z ma'lumotnomasi) va `citizenship_id_cbu` (ISO 3166-1 raqamli).
 * 470 ta mijozdan 468 tasida `860` keladi, ya'ni O'zbekiston.
 *
 * Ro'yxat to'liq emas va bo'lishi ham shart emas: mintaqa uchun
 * haqiqiy bo'lgan mamlakatlar kiritilgan, notanish kod esa o'zi
 * ko'rsatiladi — bu «—» dan yaxshiroq va sotuvchi uni provayderga
 * ayta oladi.
 */
const COUNTRIES = {
    '860': { uz: "O'zbekiston", ru: 'Узбекистан' },
    '398': { uz: 'Qozog‘iston', ru: 'Казахстан' },
    '417': { uz: 'Qirg‘iziston', ru: 'Кыргызстан' },
    '762': { uz: 'Tojikiston', ru: 'Таджикистан' },
    '795': { uz: 'Turkmaniston', ru: 'Туркменистан' },
    '643': { uz: 'Rossiya', ru: 'Россия' },
    '004': { uz: 'Afg‘oniston', ru: 'Афганистан' },
    '031': { uz: 'Ozarbayjon', ru: 'Азербайджан' },
    '051': { uz: 'Armaniston', ru: 'Армения' },
    '112': { uz: 'Belarus', ru: 'Беларусь' },
    '156': { uz: 'Xitoy', ru: 'Китай' },
    '268': { uz: 'Gruziya', ru: 'Грузия' },
    '356': { uz: 'Hindiston', ru: 'Индия' },
    '410': { uz: 'Janubiy Koreya', ru: 'Южная Корея' },
    '586': { uz: 'Pokiston', ru: 'Пакистан' },
    '792': { uz: 'Turkiya', ru: 'Турция' },
    '804': { uz: 'Ukraina', ru: 'Украина' },
    '840': { uz: 'AQSH', ru: 'США' },
};
/**
 * Ma'lumotnomadagi nom. Kod notanish bo'lsa — `null`.
 *
 * Provayderlarga yuborish uchun shu ishlatiladi: notanish kodni nom
 * o'rniga qo'yib yuborish — yolg'on ma'lumot berish demakdir.
 */
export function knownCountryName(code, lang = DEFAULT_LANG) {
    if (!code)
        return null;
    // Ma'lumotnomalarda `4` va `004` bir xil mamlakat.
    const padded = String(code).trim().padStart(3, '0');
    return COUNTRIES[padded]?.[lang] ?? COUNTRIES[padded]?.[DEFAULT_LANG] ?? null;
}
/**
 * Ekran uchun nom.
 *
 * Kod noma'lum bo'lsa — kodning o'zi qaytadi: sotuvchi uni
 * provayderga aytib, savolini aniq qo'ya oladi. Bu faqat ko'rsatish
 * uchun; yuborish uchun `knownCountryName` ishlatiladi.
 */
export function countryName(code, lang = DEFAULT_LANG) {
    if (!code)
        return null;
    return knownCountryName(code, lang) ?? String(code);
}
//# sourceMappingURL=countries.js.map